<template>
  <div id="homepage">
    <div id="first_section">
      <div class="intro">
        <img
          class="img-background crop-img"
          src="https://firebasestorage.googleapis.com/v0/b/mpro-mvp.appspot.com/o/lYAPF6wR0PQP1R4RZzfm?alt=media&token=4a6f69e2-a5fc-4e14-8973-3073bab8fb3d"
          alt
        />
        <div class="intro-content container">
          <div class="col-lg-8 col-md-10" style="margin-top:-50px">
            <div class="medium-purple-36 margin-bottom">ร่วมเป็นเจ้าของคอนโดหรูได้ง่ายๆ</div>
            <div class="medium-black-20" style="margin-bottom:2rem; width: 500px;">
              คุณสามารถทำกำไรและเป็นเจ้าของคอนโดหรูหลักสิบล้านได้ง่ายๆ
              ด้วยเงินลงทุนเริ่มต้นเพียงหลักแสน
            </div>
            <div class="small-screen-center">
              <vs-button
                color="#533D67"
                class="medium-white-18 create-invest-btn"
                @click="changePage('project')"
              >{{ $t('button.createInvest') }}</vs-button>
            </div>
          </div>
        </div>
      </div>
      <div class="core-feature">
        <div class="row">
          <div class="col-lg-3 col-md-6 feature-item">
            <img src="../assets/icons/budget-icon.svg" class="margin-bottom" alt />
            <div class="medium-black-18">
              ใช้เงินลงทุนต่ำ
              <br />เพื่อกระจายความเสี่ยง
            </div>
          </div>
          <div class="col-lg-3 col-md-6 feature-item">
            <img src="../assets/icons/chart-icon.svg" class="margin-bottom" alt />
            <div class="medium-black-18">
              ข้อมูลอสังหาริมทรัพย์แบบ
              <br />เจาะลึก โดยผู้เชี่ยวชาญ
            </div>
          </div>
          <div class="col-lg-3 col-md-6 feature-item">
            <img src="../assets/icons/secure-icon.svg" class="margin-bottom" alt />
            <div class="medium-black-18">
              ระบบที่น่าเชื่อถือ และปลอดภัย
              <br />ด้วย Blockchain Technology
            </div>
          </div>
          <div class="col-lg-3 col-md-6 feature-item">
            <img src="../assets/icons/prop-icon.svg" class="margin-bottom" alt />
            <div class="medium-black-18">
              เพียบพร้อมด้วยระบบจัดการ
              <br />การลงทุนที่ครบวงจร
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="second_section">
      <div class="about-info">
        <div class="row">
          <div class="col-md-6" style="margin:15px 0">
            <div class="service-list">
              <img src="../assets/icons/checked-icon.svg" alt />
              <div class="medium-black-20">บริการหาผู้ร่วมซื้ออสังหาริมทรัพย์ต่างๆ</div>
            </div>
            <div class="service-list">
              <img src="../assets/icons/checked-icon.svg" alt />
              <div class="medium-black-20">บริการจัดหาผู้เช่าและผู้รับซื้อต่อ</div>
            </div>
            <div class="service-list">
              <img src="../assets/icons/checked-icon.svg" alt />
              <div class="medium-black-20">บริการแบ่งผลตอบแทนจากการปล่อยเช่าอย่างเท่าเทียมกัน</div>
            </div>
            <div class="service-list">
              <img src="../assets/icons/checked-icon.svg" alt />
              <div class="medium-black-20">บริหารจัดการพอร์ตการลงทุนอย่างมีประสิทธิภาพ</div>
            </div>
            <div>
              <img src="../assets/icons/checked-icon.svg" alt />
              <div class="medium-black-20">ข้อมูลวิเคราะห์อสังหาสำหรับการตัดสินใจในการลงทุน</div>
            </div>
            <div class="regular-14 margin-top" style="padding:15px 0">
              *การแบ่งสัดส่วนผลตอบแทนค่าเช่า การตกแต่ง การดูแลและซ่อมแซม รวมถึงการจัดการปัญหาต่างๆ ทางแพลตฟอร์มจะเป็นผู้ดูแล และตัดสินใจ โดยค่าใช้จ่ายที่เกิดขึ้นทั้งหมด จะเรียกเก็บจากนักลงทุน
              อย่างเท่าเทียมกัน แต่จะมีการชี้แจงก่อนให้ทราบล่วงหน้า
            </div>
          </div>
          <div class="col-md-1 hidden-sm">
            <div class="left-line" style="height:100%; margin-left:50%"></div>
          </div>
          <div class="what-is-box col-md-5 container">
            <div class="medium-purple-36 margin-bottom">เราทำอะไร?</div>
            <div class="light-purple-18 text-start" style="margin-bottom:2rem;">
              เราคือแพลตฟอร์มที่ช่วยคุณหาเพื่อนมาร่วมซื้อคอนโด
              พร้อมบริการหาผู้เช่าครบวงจร และช่วยบริหารจัดการ
              แบ่งผลตอบแทนค่าเช่าอย่างเท่าเทียมกัน
            </div>
            <div>
              <vs-button
                color="#533D67"
                class="medium-white-18 create-invest-btn"
                @click="changePage('project')"
              >{{ $t('button.createInvest') }}</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="third_section">
      <div class="about-info">
        <div class="row">
          <div class="col-md-5 container margin-bottom small-screen-center">
            <div class="medium-purple-36 margin-bottom">ขั้นตอนการลงทุน</div>
            <div class="light-purple-18 text-start" style="margin-bottom:2rem">
              ลงทุนกับเราง่ายๆ เพียงแค่ 5 ขั้นตอนก็สามารถ
              มีกรรมสิทธิ์เป็นเจ้าของอสังหาริมทรัพย์ได้
            </div>
            <div>
              <vs-button
                color="#533D67"
                class="medium-white-18 create-invest-btn"
                @click="changePage('project')"
              >{{ $t('button.createInvest') }}</vs-button>
            </div>
          </div>
          <div class="col-md-1 hidden-sm">
            <div class="left-line" style="height:100%; margin-left:50%"></div>
          </div>
          <div class="col-md-6" style="margin:15px 0;">
            <div class="service-list">
              <img src="../assets/icons/number1.svg" alt />
              <div class="medium-black-20">เลือกโครงการคอนโดมิเนียมที่ท่านสนใจ</div>
            </div>
            <div class="service-list">
              <img src="../assets/icons/number2.svg" alt />
              <div class="medium-black-20">รอนักลงทุนรายอื่นมาร่วมจนครบตามจำนวน</div>
            </div>
            <div class="service-list">
              <img src="../assets/icons/number3.svg" alt />
              <div class="medium-black-20">
                เซ็นสัญญาซื้อขายกับเจ้าหน้าที่โครงการคอนโดโดยตรง
                พร้อมชำระด้วยเงินสด
              </div>
            </div>
            <div class="service-list">
              <img src="../assets/icons/number4.svg" alt />
              <div class="medium-black-20">รับผลตอบแทนจากการปล่อยเช่ารายเดือน</div>
            </div>
            <div>
              <img src="../assets/icons/number5.svg" alt />
              <div class="medium-black-20">ปล่อยขายกรรมสิทธิ์ที่ถิอครองเพื่อเกร็งกำไร</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="fourth_section">
      <div class="about-info">
        <div class="row">
          <div class="col-md-6" style="margin:15px 0;">
            <div class="medium-black-36 margin-bottom">ส่วนแบ่งจากการปล่อยเช่า</div>
            <div class="light-black-18" style="margin-bottom:2rem">
              ผู้ลงทุนจะได้รับผลตอบแทนจากค่าเช่าตามสัดส่วนกรรมสิทธิ์ถือครอง
              อสังหาริมทรัพย์นั้นในทุกๆเดือน ระบบจะบริหารโอนเงินค่าเช่าตามสัดส่วน
              ของผู้ร่วมลงทุนทุกคนอย่างยุติธรรมและโปร่งใส
            </div>
            <div class="medium-black-36 margin-bottom">ผลตอบแทนหลังจากการขายกรรมสิทธิ์</div>
            <div class="light-black-18" style="margin-bottom:2rem">
              ผู้ลงทุนจะได้รับผลตอบแทนหลังจากขายโอนกรรมสิทธิ์ตามสัดส่วนที่ตนเอง
              ถือครอง ซึ่งสามารถทำกำไรได้จากมูลค่าที่เพิ่มขึ้นของอสังหาริมทรัพย์นั้น
              ตามราคาตลาด
            </div>
          </div>
          <div class="col-md-1 hidden-sm">
            <div class="left-line" style="height:100%; margin-left:50%"></div>
          </div>
          <div class="col-md-5 container" style="align-self: center;">
            <div class="medium-purple-36 margin-bottom">คุณจะได้เงินจากไหน?</div>
            <div class="light-purple-18" style="margin-bottom:2rem">
              ผู้ลงทุนจะได้รับผลตอบแทนจาก
              2 ช่องทาง
            </div>
            <div class="small-screen-center">
              <vs-button
                color="#533D67"
                class="medium-white-18 create-invest-btn"
                @click="changePage('project')"
              >{{ $t('button.createInvest') }}</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="fifth_section">
      <div class="about-info">
        <div class="margin-bottom">
          <label class="medium-purple-18 margin-bottom">ติดต่อสอบถามข้อมูลเพิ่มเติม</label>
          <textarea class="form-control" id="contact-textarea" rows="6" v-model="comment"></textarea>
        </div>
        <div class="margin-bottom send-btn-box">
          <vs-button
            color="#533D67"
            class="medium-white-18 send-comment-btn"
            @click="send()"
          >{{ $t('button.send') }}</vs-button>
        </div>
        <div>
          <span class="medium-blue-18" @click="seeFAQ()" style="cursor: pointer">คำถามที่พบบ่อย ></span>
        </div>
        <div
          class="regular-bold-red-18"
          style="line-height:2"
        >*หากต้องการติดต่อโดยตรง กรุณาติดต่อได้ที่อีเมล support@fractprop.co.th</div>
      </div>
    </div>
    <SendSuccessModal ref="successModal"></SendSuccessModal>
  </div>
</template>

<script>
import { submitComment } from '@/firebase/firebase-transaction'
import SendSuccessModal from '@/components/SendSuccessModal'
import { PDF_FILE_URL } from '@/common/constant'
export default {
  data: () => ({ comment: '' }),
  components: {
    SendSuccessModal
  },
  methods: {
    changePage(des) {
      this.$router.push('project')
    },
    async send() {
      await submitComment(this.comment)
      this.$refs.successModal.openModal()
      this.comment = ''
    },
    seeMoreDetail() {
      window.open(PDF_FILE_URL)
    },
    seeFAQ() {
      this.$router.push('FAQ')
    }
  }
}
</script>

<style>
@import '../styles/HomePageStyle.css';
</style>
